<div class="user-box position-relative ml-2" dropdown>
  <a dropdownToggle [routerLink]="" class="p-0 d-flex align-items-center">
    <!-- <div class="d-block p-0 avatar-icon-wrapper avatar-icon-sm">
      <span class="p-top-a"></span>
      <div class="avatar-icon-wrapper">
        <div class="avatar-icon"><img src="assets/images/avatars/avatar1.jpg" alt="..." /></div>
      </div>
    </div> -->
    <div class="d-block p-0 avatar-icon-wrapper avatar-initials avatar-icon-sm">
      <div class="avatar-icon text-white bg-primary">
        {{letters}}
      </div>
  </div>
    <div class="d-none d-xl-block pl-2">
      <div class="font-weight-bold" style="color:#fff">
        {{currentUserName}}
      </div>
      <!-- <span class="text-white-50">
          Super Admin
        </span> -->
    </div>
    <span class="pl-1 pl-xl-3">
      <fa-icon style="color:#fff" [icon]="['fas', 'angle-down']"></fa-icon>
    </span>
  </a>
  <div *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown-menu-lg p-0">
    <ul class="list-group list-group-flush text-left bg-transparent">
      <li class="list-group-item rounded-top">
        <ul class="nav nav-neutral-primary nav-pills flex-column">
          <li class="nav-item">
            <a class="nav-link" (click)="openSettings()">
              Profile
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="openSettings()">
              Change Password
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="openModal(errorModal)">
              Logout
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>



<ng-template #errorModal>
  <div class="text-center p-5">
    <div class="avatar-icon-wrapper rounded-circle m-0">
      <div
        class="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-neutral-danger text-danger m-0 d-130">
        <fa-icon [icon]="['fas', 'sign-out-alt']" class="d-flex align-self-center display-3"></fa-icon>
      </div>
    </div>
    <h4 class="font-weight-bold mt-4">Are you sure you want to logout?</h4>
    <!-- <p class="mb-0 font-size-lg text-muted">You cannot undo this operation.</p> -->
    <div class="pt-4">
      <button (click)="decline()" class="btn btn-pill btn-neutral-secondary mx-1" type="button">
        <span class="btn-wrapper--label">
          Cancel
        </span>
      </button>
      <button (click)="confirm()" class="btn btn-pill btn-danger mx-1" type="button">
        <span class="btn-wrapper--label">
          Logout
        </span>
      </button>
    </div>
  </div>
</ng-template>